import { NormalizedUnitValue } from '@/helpers/unit-formatter/shared/types';
import { isNullOrUndefined } from '@/utils/is-null-or-undefined';

import { coerceBooleanLike } from './coerce-boolean-like';

export const transformOpenClosed = (
  unitValue: NormalizedUnitValue,
  newUnits?: string
): NormalizedUnitValue => {
  if (isNullOrUndefined(unitValue.value)) return unitValue;
  return coerceBooleanLike(unitValue, newUnits ?? 'open-closed');
};
